import { SearchResult, useSearch } from '@securecore-new-application/securecore-datacore';
import { AutoComplete, Spin } from 'antd';
import { DefaultOptionType } from 'antd/lib/select';
import { useState } from 'react';
import { Link } from 'react-router-dom';
import { useDebouncedCallback } from 'use-debounce';

import { debouncedWait } from '../../../constants';
import Icon, { IconTypes } from '../Icon/Icon';
import Input from '../Input/Input';
import { theme } from '../themes/default';
import { SearchItem } from './SearchItem';

export function Search() {
  const [query, setQuery] = useState<string>('');
  const [queryLength, setQueryLength] = useState<number>(0);

  const { data, loading } = useSearch({
    variables: {
      query,
    },
    skip: !query,
  });

  const result = data?.search.list;

  const debouncedHandleSearch = useDebouncedCallback(
    (input) => {
      setQueryLength(input.length);
      if (input.length > 2) {
        setQuery(input);
      }
    },
    // delay in ms
    debouncedWait
  );

  const renderSearchItem = (item: SearchResult, i: number) => {
    if (item.path) {
      return {
        value: item.name,
        key: `search-item-${i}-${item.id}`,
        label: (
          <Link to={item.path}>
            <SearchItem searchItem={item} query={query} />
          </Link>
        ),
      };
    }

    return {
      value: item.name,
      key: `search-item-${i}-${item.id}`,
      label: <SearchItem searchItem={item} query={query} />,
    };
  };

  const getOptions = () => {
    if (queryLength < 3 || !result) {
      return [] as DefaultOptionType[];
    }

    return result.map(renderSearchItem);
  };

  const renderNotFound = () => {
    if (queryLength < 3) {
      return 'Enter at least 3 symbols';
    }
    if (loading) {
      return (
        <div style={{ display: 'flex', justifyContent: 'center' }}>
          <Spin size="small" />
        </div>
      );
    }

    return 'Nothing was found';
  };

  return (
    <AutoComplete<SearchResult>
      style={{ width: '100%' }}
      options={getOptions()}
      onSearch={debouncedHandleSearch}
      notFoundContent={renderNotFound()}
    >
      <Input
        prefix={<Icon icon={IconTypes.Search} fillColor={theme.secondary} />}
        placeholder="Search"
        size="large"
        allowClear={{
          clearIcon: <Icon icon={IconTypes.CrossSearch} width={24} height={24} />,
        }}
        value={query}
      />
    </AutoComplete>
  );
}
